// Gọi API engine Gom Đơn (apps/gomdon, dưới /gomdon/api — spec 5.2, 5.4) bằng chính access token ShopTrack của web.
// Logic (Bearer, 401 expired / no_session → làm mới token rồi thử lại một lần, lỗi `{ error, code }`) ở request.ts.

import { getAccessToken, refreshAccessToken } from '@/lib/api'
import { createGomdonRequest } from './request'

export { GomdonError, meRetryInterval } from './request'

export const gomdonRequest = createGomdonRequest({
  fetch: (url, init) => fetch(url, init),
  getToken: getAccessToken,
  refresh: refreshAccessToken,
})

export const gomdon = {
  get: <T>(path: string) => gomdonRequest<T>('GET', path),
  post: <T>(path: string, body?: unknown) => gomdonRequest<T>('POST', path, body ?? {}),
  /** Gửi 1 tệp làm thân yêu cầu (Content-Type = loại tệp) */
  upload: <T>(path: string, file: Blob) => gomdonRequest<T>('POST', path, file),
  del: <T>(path: string) => gomdonRequest<T>('DELETE', path),
}
